import { Paper, Stack, Typography } from "@mui/material";
import classNames from "classnames";
import { T } from "components/util/t";

export const RankingsSummaryCompact = ({ selectedSeries, selectedDivision, ranking, isMobile, className }) => (
    <Stack {...isMobile && { width: "100%", left: 0, paddingY: 2, paddingX: 3, position: "absolute", component: Paper, square: true, zIndex: 1 }} className={classNames(className)}>
        <Typography color="textSecondary" variant="label2" textTransform="uppercase">{selectedSeries.name}</Typography>
        <Stack direction="row" alignItems="center" spacing={1}>
            <Typography color="text.primary" variant="subtitle3">{selectedDivision.name}</Typography>
            <Typography color="text.primary" variant="subtitle3">•</Typography>
            <Typography color="text.primary" variant="subtitle3" whiteSpace="nowrap"><T>Rank</T>{" "}<T rank={ranking.place}>#rank</T></Typography>
            <Typography color="text.primary" variant="subtitle3">•</Typography>
            <Typography color="text.primary" variant="subtitle3" whiteSpace="nowrap">{ranking.points.toLocaleString()}{" "}<T>pts</T></Typography>
        </Stack>
    </Stack>
);
